import { render, staticRenderFns } from "./YA_HomeContact.vue?vue&type=template&id=17022deb&scoped=true"
import script from "./YA_HomeContact.vue?vue&type=script&lang=js"
export * from "./YA_HomeContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17022deb",
  null
  
)

export default component.exports